<template>
    <div class="modal-browser-overlay d-flex align-items-center justify-content-center">
        <div class="donation-card shadow-2xl bg-white overflow-hidden position-relative p-4">
            
            <!-- HEADER -->
            <div class="d-flex align-items-center justify-content-between pb-3 border-bottom mb-4">
                <h5 class="fw-bold text-dark mb-0">Compartilhar Campanha</h5>
                <button type="button" class="btn-close" @click="$emit('close')" aria-label="Fechar"></button>
            </div>

            <!-- BOTÃO NATIVO DE COMPARTILHAMENTO (Celular) -->
            <button v-if="canNativeShare" @click="nativeShare" class="btn btn-light w-100 fw-bold py-3 mb-3 border d-flex align-items-center justify-content-center gap-2 text-dark">
                <i class="bi bi-share-fill text-primary"></i> Compartilhar via...
            </button>

            <!-- REDES SOCIAIS E ATALHOS -->
            <div class="d-grid gap-2 mb-4">
                <!-- WhatsApp -->
                <a :href="whatsappUrl" target="_blank" class="share-option-btn d-flex align-items-center p-3 text-decoration-none rounded-3 text-dark bg-whatsapp-subtle">
                    <div class="icon-box bg-success text-white me-3 rounded-circle d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                        <i class="bi bi-whatsapp fs-5"></i>
                    </div>
                    <div class="flex-grow-1">
                        <span class="fw-bold d-block">WhatsApp</span>
                        <span class="text-muted small">Enviar para amigos ou grupos</span>
                    </div>
                    <i class="bi bi-chevron-right text-muted"></i>
                </a>

                <!-- Telegram -->
                <a :href="telegramUrl" target="_blank" class="share-option-btn d-flex align-items-center p-3 text-decoration-none rounded-3 text-dark">
                    <div class="icon-box bg-info text-white me-3 rounded-circle d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                        <i class="bi bi-telegram fs-5"></i>
                    </div>
                    <div class="flex-grow-1">
                        <span class="fw-bold d-block">Telegram</span>
                        <span class="text-muted small">Compartilhar no canal ou chat</span>
                    </div>
                    <i class="bi bi-chevron-right text-muted"></i>
                </a>

                <!-- E-mail -->
                <a :href="emailUrl" class="share-option-btn d-flex align-items-center p-3 text-decoration-none rounded-3 text-dark">
                    <div class="icon-box bg-secondary text-white me-3 rounded-circle d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                        <i class="bi bi-envelope-fill fs-5"></i>
                    </div>
                    <div class="flex-grow-1">
                        <span class="fw-bold d-block">E-mail</span>
                        <span class="text-muted small">Enviar mensagem por e-mail</span>
                    </div>
                    <i class="bi bi-chevron-right text-muted"></i>
                </a>
            </div>

            <!-- COPIAR LINK -->
            <label class="form-label small fw-bold text-muted mb-1">Ou copie o link da página</label>
            <div class="input-group shadow-sm border rounded-3 overflow-hidden">
                <input type="text" class="form-control border-0 bg-light text-muted small" :value="pageUrl" readonly>
                <button class="btn btn-dark fw-bold px-4" @click="copyLink">
                    {{ copied ? 'COPIADO!' : 'COPIAR' }}
                </button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'ShareModal',
    props: {
        title: { type: String, default: 'Confira esta campanha' }
    },
    data() {
        return {
            pageUrl: window.location.href,
            copied: false,
            canNativeShare: !!navigator.share
        }
    },
    computed: {
        shareText() {
            return `Ajude a apoiar a campanha "${this.title}" acessando o link: `;
        },
        whatsappUrl() {
            const text = encodeURIComponent(this.shareText + this.pageUrl);
            return `https://api.whatsapp.com/send?text=${text}`;
        },
        telegramUrl() {
            const text = encodeURIComponent(this.shareText);
            return `https://t.me/share/url?url=${encodeURIComponent(this.pageUrl)}&text=${text}`;
        },
        emailUrl() {
            const subject = encodeURIComponent(`Ajude esta causa: ${this.title}`);
            const body = encodeURIComponent(`Olá!\n\nEncontrei esta campanha e achei que você gostaria de conhecer:\n\n${this.title}\n${this.pageUrl}`);
            return `mailto:?subject=${subject}&body=${body}`;
        }
    },
    methods: {
        async copyLink() {
            try {
                await navigator.clipboard.writeText(this.pageUrl);
                this.copied = true;
                setTimeout(() => this.copied = false, 3000);
            } catch (err) {
                alert('Erro ao copiar link.');
            }
        },
        async nativeShare() {
            try {
                await navigator.share({
                    title: this.title,
                    text: this.shareText,
                    url: this.pageUrl,
                });
            } catch (err) {
                // Usuário cancelou ou navegador bloqueou
            }
        }
    }
}
</script>

<style scoped>
.modal-browser-overlay {
    position: fixed;
    top: 0; left: 0; width: 100vw; height: 100vh;
    background-color: rgba(15, 23, 42, 0.85);
    z-index: 9999;
    backdrop-filter: blur(8px);
    padding: 1rem;
}
.donation-card {
    width: 100%; max-width: 440px; border-radius: 24px;
}
.share-option-btn {
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    transition: all 0.2s ease;
}
.share-option-btn:hover {
    background-color: #f1f5f9;
    border-color: #cbd5e1;
    transform: translateY(-1px);
}
</style>